import Axios from 'axios';
import { url } from 'utils/url';

// Plain API helpers for the Social Feed (Events tab). Kept out of redux:
// the feed is local to one component and never shared with other pages.
const auth = () => ({
  Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
});

const unwrap = (p) =>
  p
    .then((r) => r.data)
    .catch((error) => {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message ||
        'Request failed';
      throw new Error(message);
    });

export const getSocialStatus = (siteId) =>
  unwrap(Axios.get(`${url}/social/status`, { params: { siteId }, headers: auth() }));

export const listHashtags = (siteId) =>
  unwrap(Axios.post(`${url}/social/hashtag/list`, { siteId }, { headers: auth() }));

export const createHashtag = ({ siteId, hashtag, platforms, mediaOnly }) =>
  unwrap(
    Axios.post(
      `${url}/social/hashtag/create`,
      { siteId, hashtag, platforms, mediaOnly },
      { headers: auth() }
    )
  );

export const editHashtag = ({ siteId, id, ...changes }) =>
  unwrap(
    Axios.put(`${url}/social/hashtag/edit`, { siteId, id, ...changes }, { headers: auth() })
  );

export const deleteHashtag = ({ siteId, id }) =>
  unwrap(Axios.post(`${url}/social/hashtag/delete`, { siteId, id }, { headers: auth() }));

export const filterSocialPosts = (params) =>
  unwrap(Axios.post(`${url}/social/post/filter`, params, { headers: auth() }));

export const setSocialPostStatus = ({ siteId, ids, status }) =>
  unwrap(
    Axios.post(`${url}/social/post/status`, { siteId, ids, status }, { headers: auth() })
  );

export const importSocialPost = ({ siteId, id, title, preview, start, end, status, file }) => {
  const form = new FormData();
  form.set('siteId', siteId);
  form.set('id', id);
  if (title) form.set('title', title);
  if (preview !== undefined) form.set('preview', preview);
  if (start) form.set('start', start);
  if (end) form.set('end', end);
  if (status) form.set('status', status);
  if (file) form.append('file', file);
  return unwrap(
    Axios.post(`${url}/social/post/import`, form, {
      headers: { ...auth(), 'content-type': 'multipart/form-data' },
    })
  );
};

export const pollSocialNow = (siteId) =>
  unwrap(Axios.post(`${url}/social/poll`, { siteId }, { headers: auth() }));
